<template>
  <span>{{ money }}</span>
</template>

<script>
import Vue from "vue";
import { formatM } from "@/lib/utils/accountingJsFns";

export default Vue.extend({
  name: "UltimaFacturaComponent",
  computed: {
    money() {
      return formatM(this.params.data.ultima_factura);
    },
  },
});
</script>

<style scoped></style>
